__turbopack_context__.v({
  "button": "basket-clear-modal-module-scss-module__vYGExq__button",
  "description": "basket-clear-modal-module-scss-module__vYGExq__description",
  "modal": "basket-clear-modal-module-scss-module__vYGExq__modal",
  "title": "basket-clear-modal-module-scss-module__vYGExq__title",
});
